module.exports = __webpack_public_path__ + "media/images/iconPaginateFirst__inFrontOfAccent-5a374b4bc73aedf41aefb13c79a74e0e.png";